import default_state from "./default_state";

export const RESET_STATE = (state) => {
    Object.assign(state, default_state())
}

export const SET_PIXELS_KEYS = (state, keys) => {
    state.pixels_keys = keys
}

export const SET_PIXELS_KEY = (state, {index, value}) => {
    state.pixels_key[index] = value
}

export const SET_PIXELS_VALUE = (state, {index, value}) => {
    state.pixels_value[index] = value
}

export const SET_KEY_AND_VALUE_PAIR = (state, value) => {
    state.pixels_key.push(value)
    state.pixels_value.push(value)
}

export const REMOVE_KEY_AND_VALUE_PAIR = (state, index) => {
    state.pixels_value.splice(index, 1);
    state.pixels_key.splice(index, 1);
}